import { Corner } from 'components/balloon'
import { IStyleProps } from './Interface'
import { makeStyles, Theme } from '@material-ui/core/styles'

const getCenterPosition = (corner = Corner.BottomLeft) => {
  const positions = {
    [Corner.TopLeft]: '-35px',
    [Corner.TopRight]: '-20px',
    [Corner.BottomRight]: '-20px',
    [Corner.BottomLeft]: '-20px'
  }

  return corner in positions ? positions[corner] : positions[Corner.BottomLeft]
}

export default makeStyles<Theme, IStyleProps>(
  theme => ({
    content: {
      transform: ({ corner }) => `translateY(${getCenterPosition(corner)})`,
      position: 'relative'
    },
    title: {
      color: 'rgba(255, 255, 255)',
      fontSize: 15,
      fontWeight: 300,
      lineHeight: 1.2
    },
    errorIndicator: {
      position: 'absolute',
      top: '-15px',
      left: '-30px',
      color: theme.palette.common.yellow
    },
    input: {
      color: '#FFF',
      width: '100%',
      padding: 0,
      background: 'transparent',
      paddingTop: 10,
      '& .MuiOutlinedInput-input': {
        lineHeight: 1,
        background: 'transparent',
        paddingLeft: 0,
        paddingTop: 4,
        '&::-webkit-scrollbar': {
          width: 5
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 5px #e1dddd',
          borderRadius: 10
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#FFF',
          borderRadius: 10
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: 'rgba(255, 255, 255, 0.6)'
        }
      },
      '& .MuiOutlinedInput-notchedOutline': {
        background: 'transparent',
        border: 'none'
      }
    },
    inputError: {
      '& .MuiOutlinedInput-inputMultiline': {
        maxHeight: '50px !important'
      }
    }
  }),
  { index: 1 }
)
